<template>
  <v-card>
    <v-card-title class="justify-center">
        <h2>
          {{
            !bandeira ?
            'ADICIONAR BANDEIRA'
            :
            'EDITAR BANDEIRA'
          }}
        </h2>
    </v-card-title>
    <v-container flex>
      <v-form lazy-validation v-model="valid" ref="formBandeira">
        <v-layout row wrap fill-height justify-space-between>
            <v-flex xs12>
                <v-text-field
                  label="Nome"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="dadosBandeira.nome"
                  required
                >
                </v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                  label="Referência"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="dadosBandeira.referencia"
                  required
                >
                </v-text-field>
            </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
        <v-btn flat color="info" @click="fechar()">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="info" @click="inserirBandeira()">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  props: ['bandeira'],
  data () {
    return {
      valid: false,
      dadosBandeira: {
        nome: null,
        referencia: null
      }
    }
  },
  beforeMount () {
    if (this.bandeira) {
      this.dadosBandeira = {
        ...this.bandeira
      }
    }
  },
  methods: {
    fechar () {
      this.$refs.formBandeira.reset()
      this.$emit('fechar')
    },
    inserirBandeira () {
      if (this.$refs.formBandeira.validate()) {
        this.$store.dispatch('gerenciarBandeiras', {
          method: this.bandeira ? 'PUT' : 'POST',
          id: this.bandeira ? this.bandeira.id : undefined,
          body: {
            ...this.dadosBandeira,
            referencia: this.dadosBandeira.referencia.toUpperCase()
          }
        }).then(() => {
          this.$emit('carregar')
          this.$emit('info', 'Bandeira adicionada com sucesso')
          this.fechar()
        }).catch(() => {
          this.$emit('error', 'Não foi possível adicionar a bandeira')
          this.fechar()
        })
      }
    }
  }
}
</script>
